<ngx-loading-bar [includeSpinner]="false" color="#a4262c" height="5px"></ngx-loading-bar>
<router-outlet></router-outlet>
